import React, { useEffect, useRef, useState } from 'react'
import ReactQuill from 'react-quill';
import { formats, modules } from './Editor';
import 'react-quill/dist/quill.snow.css';
import './Quill.scss';
import { StringMap } from 'quill';

interface IProps {
    initialContent: string;
    handleChange?: (content: string) => void;
    modules?: StringMap;
    formats?: string[];
    placeholder?: string;
    maxLength?: number;
    disabled?: boolean;
    setRemainingCharacters?: (count: number) => void;
}

export const Quill: React.FC<IProps> = (props: IProps) => {
    const [quillContent, setQuillContent] = useState(props.initialContent);
    const quillRef = useRef<ReactQuill | null>(null);

    useEffect(() => {
        if (props.initialContent !== undefined) {
            setQuillContent(props.initialContent);
            if (props.setRemainingCharacters && props.maxLength) {
                const plainText = stripHtml(props.initialContent);
                props.setRemainingCharacters(props.maxLength - plainText.length);
            }
        }
    }, [props.initialContent, props.maxLength, props.setRemainingCharacters]);

    const checkCharacterCount = (event: React.KeyboardEvent) => {
        if (props.maxLength) {
            const editor = quillRef.current?.getEditor();
            const html = editor?.root.innerHTML || "";
            const plainText = stripHtml(html);
            if (plainText.length >= props.maxLength && event.key !== 'Backspace' && !event.ctrlKey) {
                event.preventDefault();
            }
        }
    };

    const handleContentChange = (content: string) => {
        setQuillContent(content);

        const plainText = stripHtml(content);
        if (props.setRemainingCharacters && props.maxLength) {
            const remaining = props.maxLength - plainText.length;
            props.setRemainingCharacters(remaining);
        }

        if (plainText == "" ){
            content = plainText;
        }

        if (props.handleChange) {
            props.handleChange(content);
        }
    };

    function stripHtml(html: string) {
        const tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
    }

    return (
        <div>
            <ReactQuill
                ref={quillRef}
                readOnly={props.disabled}
                theme="snow"
                onChange={handleContentChange}
                onKeyDown={checkCharacterCount}
                value={quillContent}
                modules={props.modules ?? modules}
                formats={props.formats ?? formats}
                bounds={'.app'}
                placeholder={props.placeholder ?? "Write something..."}
            />
        </div>
    );
};
